/**
 * toBooleanEnabled	统一解析启用/关闭布尔值
 * parseRadioEnabledValue	解析 radio @change 事件值
 * normalizeSalePriceRateConfig	标准化建议销售价配置
 * normalizeSalePriceSumConfig	标准化销售价配置
 * resolvePriceRuleExclusive	处理两项启用互斥
 * normalizeAccountItem	新建/编辑时初始化表单数据
 * applyPriceRuleEnabledChange	切换启用/关闭逻辑
 * validatePriceConfigField	单字段校验，返回错误文案
 * createPriceConfigValidator	生成 Ant Design 字段 validator
 */
export function toBooleanEnabled(value, defaultValue = false) {
  if (value === true || value === 'true') {
    return true
  }
  if (value === false || value === 'false') {
    return false
  }
  return defaultValue
}

export function parseRadioEnabledValue(e) {
  const rawEnabled = e && e.target ? e.target.value : e
  return toBooleanEnabled(rawEnabled, false)
}

export function normalizeSalePriceRateConfig(value) {
  if (value && typeof value === 'object') {
    return {
      enabled: toBooleanEnabled(value.enabled, true),
      salePriceRate: value.salePriceRate
    }
  }
  return {
    enabled: true,
    salePriceRate: typeof value === 'number' ? value : undefined
  }
}

export function normalizeSalePriceSumConfig(value) {
  if (value && typeof value === 'object') {
    return {
      enabled: toBooleanEnabled(value.enabled, false),
      salePriceSum: value.salePriceSum
    }
  }
  return {
    enabled: false,
    salePriceSum: typeof value === 'number' ? value : undefined
  }
}

export function resolvePriceRuleExclusive(normalized) {
  if (normalized.salePriceRate.enabled && normalized.salePriceSum.enabled) {
    const rateHasValue = normalized.salePriceRate.salePriceRate != null
    const sumHasValue = normalized.salePriceSum.salePriceSum != null
    if (sumHasValue && !rateHasValue) {
      normalized.salePriceRate.enabled = false
    } else {
      normalized.salePriceSum.enabled = false
    }
  }
  if (!normalized.salePriceRate.enabled && !normalized.salePriceSum.enabled) {
    normalized.salePriceRate.enabled = true
  }
  return normalized
}

export function normalizeAccountItem(item = {}) {
  const normalized = { ...item }
  normalized.salePriceRate = normalizeSalePriceRateConfig(item.salePriceRate)
  normalized.salePriceSum = normalizeSalePriceSumConfig(item.salePriceSum)
  return resolvePriceRuleExclusive(normalized)
}

export function getOtherPriceConfigKey(configKey) {
  return configKey === 'salePriceRate' ? 'salePriceSum' : 'salePriceRate'
}

export function applyPriceRuleEnabledChange(form, configKey, enabled, set) {
  const otherKey = getOtherPriceConfigKey(configKey)
  set(form[configKey], 'enabled', enabled)
  if (enabled) {
    set(form[otherKey], 'enabled', false)
  } else if (!toBooleanEnabled(form[otherKey].enabled, false)) {
    set(form[otherKey], 'enabled', true)
  }
}

export function validatePriceConfigField(value, configKey) {
  if (value === undefined || value === null || value === '') {
    return configKey === 'salePriceRate' ? '请填写建议销售价比例' : '请填写销售金额'
  }
  if (configKey === 'salePriceRate' && Number(value) < 0) {
    return '数值不能小于0'
  }
  return null
}

export function createPriceConfigValidator(configKey) {
  return (rule, value, callback) => {
    const error = validatePriceConfigField(value, configKey)
    if (error) {
      callback(new Error(error))
      return
    }
    callback()
  }
}
